/* eslint-disable */
const customRegex = {
  validZip: {
    es: /^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/,
    fr: /^(?:[0-8]\d|9[0-8])\d{3}$/,
    it: /^[0-9]{5}$/,
  },
  // Minimum eight characters, at least one uppercase letter, one lowercase letter and one number.
  strongPassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
  weakPassword: /^.{6,}$/,
  emoji: /(\p{Emoji_Presentation}|\p{Emoji}\uFE0F)(\u200D(\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\p{Symbol}))*/gu,
  alphaLatin: /^[A-Za-zÀ-ÖØ-öø-ÿ'`´\s\-]+$/i,
  alphanumericLatin: /^[A-Za-zÀ-ÖØ-öø-ÿ0-9'`´\s\-]+$/i,
  nonAlphanumericLatinWithSymbols: /[^A-Za-zÀ-ÖØ-öø-ÿ0-9.,:;'`´\s\-/()&\[\]]/g,
}

export default customRegex
